var React = require('react');

function BurgerMenu (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"2.1","y1":"2.2","x2":"13.9","y2":"2.2","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"2.1","y1":"13.8","x2":"13.9","y2":"13.8","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"2.1","y1":"7.9","x2":"13.9","y2":"7.9","key":2})]));
}

BurgerMenu.displayName = "BurgerMenu";

BurgerMenu.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = BurgerMenu;

BurgerMenu.default = BurgerMenu;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/burgerMenu.svg
// module id = ../icon/src/icons/burgerMenu.svg
// module chunks = 0